import React, { Component } from 'react';
import { Navbar } from 'reactstrap';
import './footer.scss';

class Footer extends Component {
  render() {
    return (
      <Navbar className="bb-footer" light expand="md">
        <div className="center-container">
          <div>
            <p>Made with <i className="fas fa-heart"></i> by the Bit Benders Team</p>
            <div className="center-container">
              <a target="_blank" rel="noopener noreferrer" className="social-media" href="https://www.facebook.com/bitbenders/"><i className="fab fa-facebook-f"></i></a>
              <a target="_blank" rel="noopener noreferrer" className="social-media" href="https://www.instagram.com/bitbenders/"><i className="fab fa-instagram"></i></a>
              <a target="_blank" rel="noopener noreferrer" className="social-media" href="https://twitter.com/bitbendersllc"><i className="fab fa-twitter"></i></a>
              <a target="_blank" rel="noopener noreferrer" className="social-media" href="https://www.linkedin.com/company/bit-benders/"><i className="fab fa-linkedin-in"></i></a>
            </div>
          </div>
        </div>
      </Navbar>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/footer.js